import { Component } from '@angular/core';

@Component({
  selector: 'app-meetings-janus',
  standalone:false,
  templateUrl: './meetings-janus.component.html',
  styleUrl: './meetings-janus.component.scss'
})
export class MeetingsJanusComponent {

}
